import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Estadisticas from './pages/Estadisticas';
import Matricula from './pages/Matricula';
import Atrasos from './pages/Atrasos';
import AtrasosAula from './pages/AtrasosAula';
import CargaAsistencia from './pages/CargaAsistencia';
import GestionUsuarios from './pages/GestionUsuarios';
import FluidezLectora from './pages/FluidezLectora';
import FluidezMatematicas from './pages/FluidezMatematicas';
import ResumenFluidez from './pages/ResumenFluidez';
import AusentismoCronico from './pages/AusentismoCronico';
import StudentProfile from './pages/StudentProfile';
import ElectivosSelection from './pages/ElectivosSelection';
import ElectivosAdmin from './pages/ElectivosAdmin';
import PanelControlElectivos from './pages/PanelControlElectivos';
import MiPerfil from './pages/MiPerfil';
import Seguridad from './pages/seguridad'; 
import './App.css';

function App() {
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  
  console.log("App - Token:", token);
  console.log("App - Rol:", role);

  const getDefaultRoute = () => {
    if (!role) return "/dashboard";
    
    const lowerRole = role.toLowerCase();

    if (lowerRole === 'convivencia') return "/Atrasos";
    if (role === 'Profesor Jefe') return "/matricula";
    if (role === 'Fluidez') return "/resumen-fluidez";
    
    // Rutas para los nuevos roles
    if (role === 'Estudiante') return "/student/profile";
    if (role === 'Electivos Admin') return "/electivos-admin";
    if (role === 'Funcionario') return "/mi-perfil";
    return "/dashboard";
  };

  return (
    <Router>
      {token ? (
        <div className="app-container">
          <Sidebar />
          <div className="main-content">
            <Routes>
              {/* Ruta Raíz: Redirige automáticamente según el rol apenas entra */}
              <Route path="/" element={<Navigate to={getDefaultRoute()} replace />} />

              {/* Redirecciones condicionales según rol para el Dashboard común */}
              <Route 
                path="/dashboard" 
                element={
                  role && role.toLowerCase() === 'convivencia' ? 
                  <Navigate to="/Atrasos" replace /> : 
                  <Dashboard />
                } 
              />
              
              <Route 
                path="/estadisticas" 
                element={
                  role && role.toLowerCase() === 'convivencia' ? 
                  <Navigate to="/Atrasos" replace /> : 
                  <Estadisticas />
                } 
              />

              <Route 
                path="/matricula" 
                element={
                  role && role.toLowerCase() === 'convivencia' ? 
                  <Navigate to="/Atrasos" replace /> : 
                  <Matricula />
                } 
              />

              {/* Páginas generales */}
              <Route path="/Atrasos" element={<Atrasos />} />
              <Route path="/AtrasosAula" element={<AtrasosAula />} />
              <Route path="/carga-asistencia" element={<CargaAsistencia />} />
              <Route path="/gestion-usuarios" element={<GestionUsuarios />} />
              
              {/* Programa de Fluidez */}
              <Route path="/resumen-fluidez" element={<ResumenFluidez />} />
              <Route path="/fluidez-lectora" element={<FluidezLectora />} />
              <Route path="/fluidez-matematicas" element={<FluidezMatematicas />} />
              <Route path="/AusentismoCronico" element={<AusentismoCronico />} />

              {/* Módulo Estudiantes */}
              {role === 'Estudiante' && (
                <>
                  <Route path="/student/profile" element={<StudentProfile />} />
                  <Route path="/student/electivos" element={<ElectivosSelection />} />
                </>
              )}

              {/* Módulo Admin Electivos */}
              {role === 'Electivos Admin' && (
                <>
                  <Route path="/electivos-admin" element={<ElectivosAdmin />} />
                  <Route path="/paneldecontrol-admin" element={<PanelControlElectivos />} />
                </>
              )}
              
              {/* Módulo Funcionario CORREGIDO: Seguridad queda blindado aquí adentro */}
              {role === 'Funcionario' && (
                <>
                  <Route path="/mi-perfil" element={<MiPerfil />} />
                  <Route path="/seguridad" element={<Seguridad />} />
                </>
              )}

              {/* Ruta fallback: Si nada coincide, usa la lógica de getDefaultRoute */}
              <Route path="*" element={<Navigate to={getDefaultRoute()} replace />} />
            </Routes>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;